export default __webpack_public_path__ + "static/media/symfony-negative.cab1b109.svg";